var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigestive1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.118,
    height: 47,
    viewBox: "0 0 29.118 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7638",
    "data-name": "Group 7638",
    transform: "translate(-366.723 -641.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4316",
    "data-name": "Path 4316",
    d: "M395.806,715.787H366.728v-.574c0-5.3-.019-10.594.016-15.891.007-1.04.228-2.077.331-3.118.045-.451.272-.539.7-.538q10.435.02,20.87.01c2.08,0,4.16.009,6.24-.008.364,0,.548.087.589.469.11,1.022.343,2.041.35,3.063.036,5.366.017,10.733.016,16.1C395.835,715.453,395.817,715.606,395.806,715.787ZM376.89,703.91a12.911,12.911,0,0,0-4.345-.39c-.924,0-1.343.433-1.33,1.354a7.745,7.745,0,0,0,6.413,7.432,33.422,33.422,0,0,0,4.549.147,16.98,16.98,0,0,0,2.768-.135,7.809,7.809,0,0,0,6.4-7.505c0-.761-.392-1.279-1.078-1.281-1.134,0-2.269.038-3.4.1a8.314,8.314,0,0,0-1.207.24,9.016,9.016,0,0,0-3.748-4.624,1.054,1.054,0,0,0-1.32.034A9.019,9.019,0,0,0,376.89,703.91Z",
    transform: "translate(0 -34.663)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4317",
    "data-name": "Path 4317",
    d: "M366.742,759.017h29.1v2.37c0,.629.008,1.258,0,1.887a1.156,1.156,0,0,1-1.289,1.3q-13.265,0-26.529,0c-.766,0-1.254-.386-1.271-1.1C366.718,762.015,366.742,760.549,366.742,759.017Z",
    transform: "translate(-0.007 -75.579)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4318",
    "data-name": "Path 4318",
    d: "M370.739,675.156a11.447,11.447,0,0,1,2.959-3.737,18.077,18.077,0,0,1,1.975-1.371.659.659,0,0,0,.368-.664c-.022-.645-.007-1.291-.007-1.987h15.682c0,.573.03,1.145-.009,1.712a.987.987,0,0,0,.589,1.067,11.771,11.771,0,0,1,4.5,4.571c.066.117.123.241.207.409Z",
    transform: "translate(-2.594 -16.405)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4319",
    "data-name": "Path 4319",
    d: "M389.439,648.712q-4.326,0-8.653,0c-1,0-1.388-.4-1.39-1.4q0-1.993,0-3.986c0-.9.414-1.322,1.311-1.323q8.757,0,17.514,0c.9,0,1.309.42,1.311,1.323q.007,2.019,0,4.038c0,.934-.412,1.349-1.339,1.35Q393.818,648.716,389.439,648.712Z",
    transform: "translate(-8.185 0)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4320",
    "data-name": "Path 4320",
    d: "M411.435,728.581a5.641,5.641,0,0,1,6.329-4.412C418.017,726.5,414.614,728.882,411.435,728.581Z",
    transform: "translate(-28.878 -53.046)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4321",
    "data-name": "Path 4321",
    d: "M386.25,724.18c3.064-.382,6.121,1.752,6.349,4.4C389.478,728.915,386.435,726.821,386.25,724.18Z",
    transform: "translate(-12.612 -53.051)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4322",
    "data-name": "Path 4322",
    d: "M403.853,718.116c-.681-.682-1.428-1.38-2.1-2.143a1.048,1.048,0,0,1-.056-.869,5.867,5.867,0,0,1,1.98-2.454.359.359,0,0,1,.349.028,16.792,16.792,0,0,1,1.827,2.195c.419.687.269.971-.279,1.432A20.029,20.029,0,0,0,403.853,718.116Z",
    transform: "translate(-22.546 -45.611)",
    fill: "#aceb1e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigestive1);
export default __webpack_public_path__ + "static/media/digestive1.72a956c1c5017bf95b85aed427a50c86.svg";
export { ForwardRef as ReactComponent };